import script from "./TaskForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskForm.vue?vue&type=script&setup=true&lang=js"

import "./TaskForm.vue?vue&type=style&index=0&id=44427ef8&scoped=true&lang=scss"
import "@/assets/sass/components/task-ui.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44427ef8"]])

export default __exports__